var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "article-swiper__container" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c("div", { staticClass: "row overflow-hidden" }, [
        _c("div", { staticClass: "swiper-outer-container" }, [
          _c("div", { ref: "articleSwiper", staticClass: "swiper-container" }, [
            _c(
              "div",
              { staticClass: "swiper-wrapper" },
              _vm._l(_vm.slides, function(entry) {
                return _c("div", { staticClass: "swiper-slide d-flex" }, [
                  _c("div", { staticClass: "col-lg-6" }, [
                    _c("div", { staticClass: "article-swiper__img-wrapper" }, [
                      _c("img", {
                        attrs: {
                          src: entry.img,
                          alt: entry.headline,
                          title: entry.headline
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6" }, [
                    _c("div", { staticClass: "content" }, [
                      _c(
                        "span",
                        { staticClass: "h3 white article-swiper__headline" },
                        [_vm._v(_vm._s(entry.headline))]
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "article-swiper__text" }, [
                        _vm._v(_vm._s(entry.text))
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { href: entry.url }
                        },
                        [_vm._v(_vm._s(entry.btntext))]
                      )
                    ])
                  ])
                ])
              }),
              0
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "article-swiper__pagination-wrapper" }, [
        _c("div", {
          ref: "pagination",
          staticClass: "swiper-pagination article-swiper__pagination-wrapper"
        })
      ]),
      _vm._v(" "),
      _c("div", { ref: "prev", staticClass: "swiper-button-prev" }, [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "10",
              height: "18",
              viewBox: "0 0 10 18"
            }
          },
          [
            _c("path", {
              attrs: {
                fill: "#FFF",
                d:
                  "M8.45833178,0.292893219 L9.87254534,1.70710678 L2.414,9.165 L9.87254534,16.6237703 L8.45833178,18.0379839 L0.292893219,9.87254534 C-0.0675907428,9.51206138 -0.0953202783,8.94483033 0.209704612,8.55253912 L0.292893219,8.45833178 L8.45833178,0.292893219 Z"
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { ref: "next", staticClass: "swiper-button-next" }, [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "10",
              height: "18",
              viewBox: "0 0 10 18"
            }
          },
          [
            _c("path", {
              attrs: {
                fill: "#FFF",
                d:
                  "M8.45833178,0.292893219 L9.87254534,1.70710678 L2.414,9.165 L9.87254534,16.6237703 L8.45833178,18.0379839 L0.292893219,9.87254534 C-0.0675907428,9.51206138 -0.0953202783,8.94483033 0.209704612,8.55253912 L0.292893219,8.45833178 L8.45833178,0.292893219 Z"
              }
            })
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }